export class TabsModel {
    selectors = {
        tabContainer: "[data-js-tab-container]",
        tab: "[data-js-tab]",
        tabContentWrapper: "[data-js-tab-content-wrapper]",
        tabLoader: "[data-js-tab-loader]"
    }

    stateClasses = {
        isActive: "isActive",
        isHidden: "isHidden",
        isPointerEventsNone: "isPointerEventsNone"
    }

    static layouts = {
        loader: `<svg class="c-button__loader" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.99049 12C3.99049 10.4159 4.46024 8.86731 5.34034 7.55016C6.22043 6.233 7.47135 5.2064 8.93489 4.60018C10.3984 3.99396 12.0089 3.83535 13.5626 4.1444C15.1163 4.45345 16.5434 5.21628 17.6636 6.33643C18.7837 7.45658 19.5466 8.88374 19.8556 10.4374C20.1647 11.9911 20.006 13.6016 19.3998 15.0651C18.7936 16.5287 17.767 17.7796 16.4498 18.6597C15.1327 19.5398 13.5841 20.0095 12 20.0095L12 22C12.6751 22 13.345 21.9317 14 21.798C15.264 21.5399 16.4725 21.0385 17.5557 20.3147C19.2002 19.2159 20.4819 17.6541 21.2388 15.8268C21.9957 13.9996 22.1937 11.9889 21.8078 10.0491C21.422 8.10929 20.4696 6.32746 19.0711 4.92894C17.6725 3.53041 15.8907 2.578 13.9509 2.19215C12.0111 1.8063 10.0004 2.00433 8.17317 2.76121C6.3459 3.51808 4.78412 4.79981 3.6853 6.4443C2.96155 7.52748 2.46006 8.736 2.20204 10C2.06833 10.655 2 11.3249 2 12H3.99049Z" fill="currentColor"></path>
            </svg>`
    }

    static msg = {
        emptyData: "Нет данных",
        error: "Ошибка загрузки данных"
    }

    constructor() {
        document.querySelectorAll(this.selectors.tabContainer).forEach((container) => {
            container.querySelectorAll(this.selectors.tab).forEach((tabEl) => {
                this.#bindEvents(tabEl)
            })
        })
    }

    toggleClassesToHidden(tabContainer) {
        tabContainer.querySelectorAll(this.selectors.tabContentWrapper).forEach((el) => {
            el.classList.remove(this.stateClasses.isActive)
            el.classList.add(this.stateClasses.isHidden)
        })

        tabContainer.querySelectorAll(this.selectors.tab).forEach((el) => {
            el.classList.remove(this.stateClasses.isActive)
            el.classList.add(this.stateClasses.isHidden)
        })
    }

    toggleClassesToActive(tabEl, triggerEl) {
        tabEl.classList.remove(this.stateClasses.isHidden)
        tabEl.classList.add(this.stateClasses.isActive)
        triggerEl.classList.remove(this.stateClasses.isHidden)
        triggerEl.classList.add(this.stateClasses.isActive)
    }

    toggleTabs(tabContainer, srcContainerForRender, triggerEl) {
        let context = tabContainer || document
        const containerForRender =  context.querySelector(srcContainerForRender)
        if (!containerForRender) return
        const parent = tabContainer || containerForRender.closest(this.selectors.tabContainer)
        this.toggleClassesToHidden(parent)
        const activeContainer = containerForRender.closest(this.selectors.tabContentWrapper)
        this.toggleClassesToActive(activeContainer, triggerEl)
    }

    clearCfg(cfg, triggerEl) {
        delete cfg.endpoint
        delete cfg.method
        delete cfg.data
        delete cfg.dataType
        triggerEl.dataset.jsTab = JSON.stringify(cfg);
    }

    handleResponse(res, cfg, tabContainer, triggerEl, typeResp="success") {
        const containerForRender = tabContainer.querySelector(cfg?.srcContainerForRender) || document.querySelector(cfg?.srcContainerForRender)
        if (!containerForRender) return;
        containerForRender.insertAdjacentHTML(cfg.insertParam || "beforeend",  typeResp === "success" ? res?.data?.htmlMarkup || TabsModel.msg.emptyData : TabsModel.msg.error)
        this.reInitSwiper(containerForRender)
        this.toggleTabs(tabContainer, cfg.srcContainerForRender, triggerEl)
        this.clearCfg(cfg, triggerEl)
    }

    reInitSwiper(container) {
        if (container.parentElement.swiper) {
            container.parentElement.swiper.destroy();

            const isSwiperWrapper = container.classList.contains("swiper-wrapper");
            const swiperWrapper = isSwiperWrapper ? container : container.querySelector(":scope .swiper-wrapper");

            const slidesNum = swiperWrapper.children.length;

            if (slidesNum < 10) {
                const clonedWrapper = swiperWrapper.cloneNode(true);
                swiperWrapper.append(...clonedWrapper.children);
            }

            // const loopedSlides = container.querySelectorAll(".swiper-slide").length - 5
            // const loopedSlidesConfig = {}
            // if (loopedSlides > 0) {
            //     loopedSlidesConfig["loopedSlides"] = loopedSlides
            // }

            const swiper = new Swiper(container.parentElement, {
                slidesPerView: "auto",
                spaceBetween: 16,
                loop: true,
                pagination: {
                    el: container.parentElement.querySelector("[data-js-slider-pagination]"),
                    clickable: true,
                },
                navigation: {
                    nextEl:  container.parentElement.closest("[data-js-slider]").querySelector("[data-js-slider-right-btn]"),
                    prevEl: container.parentElement.closest("[data-js-slider]").querySelector("[data-js-slider-left-btn]"),
                },
                // loopedSlides: 3,
                // ...loopedSlidesConfig
            });
        }
    }

    showLoader(tabContainer, cfg) {
        let context = tabContainer || document
        const loader = context.querySelector(cfg?.srcContainerForRender).closest(this.selectors.tabContainer).querySelector(this.selectors.tabLoader)
        if (!loader) return
        loader.insertAdjacentHTML("beforeend", TabsModel.layouts.loader)
        loader.classList.add(this.stateClasses.isActive)
    }

    hideLoader(tabContainer, cfg) {
        let context = tabContainer || document
        const loader = context.querySelector(cfg?.srcContainerForRender).closest(this.selectors.tabContainer).querySelector(this.selectors.tabLoader)
        if (!loader) return
        loader.innerHTML = ""
        loader.classList.remove(this.stateClasses.isActive)
    }

    disableTabs(tabContainer) {
        if (!tabContainer) return;
        tabContainer.querySelectorAll(this.selectors.tab).forEach((elem) => {
            elem.classList.add(this.stateClasses.isPointerEventsNone)
        })
    }

    enableTabs(tabContainer) {
        if (!tabContainer) return;
        tabContainer.querySelectorAll(this.selectors.tab).forEach((elem) => {
            elem.classList.remove(this.stateClasses.isPointerEventsNone)
        })
    }


    async handleClick(e) {
        const attrName = this.selectors.tab.split("").slice(1,-1).join('')
        const { target: triggerEl } = e
        const tabContainer = triggerEl.closest(this.selectors.tabContainer)
        const cfg = JSON.parse(e.target.getAttribute(attrName))

        if (cfg.endpoint) {
            this.disableTabs(tabContainer)
            this.showLoader(tabContainer, cfg)
            await window.App.ApiClient.request({method: cfg?.method, endpoint: cfg?.endpoint, data: cfg?.data ?? null})
                .then((res) => {
                    this.handleResponse(res, cfg, tabContainer, triggerEl)
                })
                .catch((res) => {
                    this.handleResponse(res, cfg, tabContainer, triggerEl, "error")
                }).finally(() => {
                    this.hideLoader(tabContainer, cfg)
                    this.enableTabs(tabContainer)
                })
        } else {
            this.toggleTabs(tabContainer, cfg.srcContainerForRender, triggerEl)
        }


    }

    #bindEvents(el) {
        el.addEventListener("click", (e) => {
            this.handleClick(e)
        })
    }
}

